export default "__VITE_ASSET__SaGAqL1c__"